import styled from "styled-components";

import { colorsPalettes, mixins } from "@similarweb/styles";

export const FILTER_CONDITION_DIALOG_STYLES = {
    content: { padding: "0", border: "unset", width: "592px", borderRadius: "6px" },
};

export const StyledModalHeader = styled.div`
    padding: 20px 24px;
`;

export const StyledModalTitle = styled.h2`
    ${mixins.setFontVariant("h5", colorsPalettes.carbon[500])};
    line-height: 24px;
    margin: 0;
`;

export const StyledModalSubtitle = styled.p`
    ${mixins.setFontVariant("chip1", colorsPalettes.carbon[400])};
    line-height: 16px;
    margin: 8px 0 0;
`;

export const StyledModalContent = styled.div`
    flex-grow: 1;
    padding: 12px 24px 24px;
`;

export const StyledModalButtons = styled.div`
    display: flex;
    justify-content: flex-end;
    padding: 16px;

    & > *:not(:first-child) {
        margin-left: 4px;
    }
`;
